<div [class]="'snackbar-status snackbar-status__'+data.typeSnackbar">
    <img class="snackbar-status__icon" [src]="'../../../../../assets/images/common/icon-message-'+data.typeSnackbar+'.svg'" alt="">
    <div class="snackbar-status__body">
        <div class="snackbar-status__body__title">
            <span>{{data.title}}</span>
            <button mat-icon-button data-testid="global-snackbar-btn-close" (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
        </div>
        <div class="snackbar-status__body__text">{{data.text}}</div>
    </div>
</div>